import axiosClient from "../axios";

const TOKEN_KEY = "token";

const AuthService = {
  login: async (data) => {
    const response = await axiosClient.post("/api/login", data);
    const { token, user } = response.data;

    localStorage.setItem(TOKEN_KEY, token);
    return user;
  },

  register: async (data) => {
    const response = await axiosClient.post("/api/register", data);

    const { token, user } = response.data;

    localStorage.setItem(TOKEN_KEY, token);

    return user;
  },

  getUser: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) throw new Error("No token found, user is not logged in");

    const response = await axiosClient.get("/api/me");
    return response.data; // ✅ Fixed: return response.data directly
  },

  logout: async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) {
      await axiosClient.post("/api/logout");
      localStorage.removeItem(TOKEN_KEY);
    }
  },

  updateProfile: async (data) => {
    const response = await axiosClient.put("/api/user/profile", data);

    // If backend returns a new token, update it
    if (response.data.token) {
      localStorage.setItem(TOKEN_KEY, response.data.token);
    }

    return response;
  },
  resetPasswordWithPhone: async (data) => {
    const response = await axiosClient.post("/api/reset-password-phone", data);

    return response.data;
  },

  updateName: async (name) => AuthService.updateProfile({ name }),
  updateEmail: async (email) => AuthService.updateProfile({ email }),
  updatePhone: async (phone) => AuthService.updateProfile({ phone }),

  updatePassword: async ({ currentPassword, newPassword }) => {
    const response = await axiosClient.put("/api/user/password", {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: newPassword,
    });

    // If backend returns a new token after password change, update it
    if (response.data.token) {
      localStorage.setItem(TOKEN_KEY, response.data.token);
    }

    return response;
  },
};

export default AuthService;
